const publicPackageMonthlyRevenue = {
    excel_transition: "up_to_1m_czk",
    growing_eshop: "up_to_3m_czk",
    strong_eshop: "up_to_10m_czk",
};

export function monthlyRevenueValue(packageCode) {
    return publicPackageMonthlyRevenue[packageCode] ?? null;
}
